'use strict'

module.exports = {
    errorTypes: {
        VIDEO_GENERAL_ERROR: 'generalError',
        NO_VIDEO_FOUND: 'noVideoError'
    },
    playbackTypes: {
        IDLE: 'idle',
        LOADING: 'loading',
        READY: 'ready',
        STOPPED: 'ready',
        PLAY_ENDED: 'ended',
        PLAYING: 'playing',
        PAUSED: 'paused',
        SEEK_PLAYING: 'seek_playing',
        SEEK_PAUSED: 'seek_paused',
        SEEKING: 'seeking',
        SEEKING_ENDED: 'seek_ended',
        WAITING: 'waiting',
        ERROR: 'error'
    },
    eventTypes: {
        MOUNT: 'mount',
        LOAD: 'load',
        PLAYSTATE: 'playstate',
        VOLUME: 'volume',
        RATE: 'rate',
        TIME_UPDATE: 'timeupdate',
        PROGRESS: 'progress',
        ERROR: 'error'
    },
    availabilityReadyStates: {
        IN_PROCESS: 'in_process',
        PLAYING_PREVIEW: 'playing_preview',
        IDLE: 'idle',
        NO_VIDEO: 'no_video'
    },
    playback: {
        SUPPORTED_MEDIA_ATTRIBUTES: ['autoplay', 'mute', 'loop']
    },
    balataConsts: {
        BALATA: 'balata',
        MEDIA: 'media',
        IMAGE: 'image',
        CONTENT: 'content',
        POSTER: 'poster',
        BG_IMAGE: 'bgimage',
        VIDEO: 'video',
        OVERLAY: 'overlay',
        UNDERLAY: 'underlay',
        BG_COLOR: 'bgcolor',
        ZOOM_SELECTORS: ['.bgImage', '.bgVideo'],
        PARALLAX_SELECTORS: ['.bgImage', '.bgVideo'],
        REVEAL_SELECTORS: ['.bgImage', '.bgVideo'],
        BLUR_SELECTORS: ['.bgImage', '.bgVideo'],
        FADE_SELECTORS: ['.bgImage', '.bgVideo', '.bgColor', '.bgOverlay'],
        overlay: 'overlayTransforms',
        media: 'mediaTransforms'
    },
    defaultMediaStyle: {
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
    },
    popupMediaStyle: {
        position: 'fixed',
        pointerEvents: 'auto',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
    },
    elementQueries: {
        controls: {
            width: [
                {min: 0, max: 350, name: 'minimal'},
                {min: 0, max: 450, name: 'small'},
                {min: 450, max: 1200, name: 'normal'},
                {min: 1200, max: Infinity, name: 'large'}
            ]
        }
    }
}



// WEBPACK FOOTER //
// ./src/coreUtils/src/main/core/mediaConsts.js